import { render, staticRenderFns } from "./InvestorNavigation.vue?vue&type=template&id=07451fdd&scoped=true&"
import script from "./InvestorNavigation.vue?vue&type=script&lang=js&"
export * from "./InvestorNavigation.vue?vue&type=script&lang=js&"
import style0 from "./InvestorNavigation.vue?vue&type=style&index=0&id=07451fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07451fdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})
